import { FC } from 'react';
import { OrderManagement } from 'components/OrderManagement';
import { Page } from 'layouts/Page';

export const OrderManagementPage: FC = () => {
	return (
		<Page title="Order Management – EAS Control Center">
			<OrderManagement />
		</Page>
	);
};
